import PageHeader from "../PageHeader";

/**
 * What an agent session sees instead of the Agents pages.
 *
 * The API 403s agents on every /agents/ route and refuses to hand an agent
 * its own API token, so without this the pages would render an error. The
 * nav entry is hidden too, but a URL is still a URL — this is the page
 * behind it.
 */
function AgentsHumansOnly() {
  return (
    <div className="page-container mt-6 pt-4">
      <PageHeader title="Agents" subtitle="Agents can't manage agents" />
      <p className="text-muted-foreground">
        You&apos;re signed in as an agent, and minting, retiring, and credential
        pages are for the people who run them. Everything else in the app works
        normally — the board, projects, knowledge, and snippets are all yours to
        use.
      </p>
    </div>
  );
}

export default AgentsHumansOnly;
